import { FormField } from "@weirgroup/weir-dls";
import { InputboxProps } from "@weirgroup/weir-dls/dist/components/FormField/FormField";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import './styles.scss'

export const ModifiedFormField = <
    T extends FieldValues
>(props: InputboxProps & { control: Control<T, unknown, FieldValues>, name: Path<T> }) => {
    return (
        <div className="fieldContainer">
            <Controller
                name={props?.name}
                control={props.control}
                render={({ field, fieldState }) => (
                    <FormField fullWidth label={props.label} {...field} {...props} readonly={props.disabled} errorMessage={fieldState.error?.message} />
                )}
            />
        </div>
    );
};
